if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    document.querySelector('body').classList.add('safari')
}
var lastScrollTop = 0;

// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
window.addEventListener("scroll", function(){
   let sliders = document.querySelectorAll('.recommendation-drawer-slider')
   var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
   if (st > lastScrollTop){
      // downscroll code
      sliders.forEach(slider => {
        slider.classList.add('downhill')
        slider.classList.remove('uphill')
      });
   } else {
      sliders.forEach(slider => {
        slider.classList.remove('downhill')
        slider.classList.add('uphill')
      });
   }
   lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);

let cartToggles = document.querySelectorAll('.js-cart-toggle')
let cartCloses = document.querySelectorAll('.js-cart-close')
let cartContainers = document.querySelectorAll('.cart-container')
let overlay = document.querySelectorAll('.js-overlay')
const body = document.querySelector('body')
console.log('JS IS HERE')


cartToggles.forEach(cartToggle => {
    cartToggle.addEventListener('click', function(e){
        console.log('cart is open')
        cartContainers.forEach(cartContainer => {
            cartContainer.classList.add('active')
        })
        body.classList.remove('overlay-removed')
        body.classList.add('locked')
        e.preventDefault
    });
})
cartCloses.forEach(cartClose => {
    cartClose.addEventListener('click', function(e){
        console.log('cart is closed')
        cartContainers.forEach(cartContainer => {
            cartContainer.classList.remove('active')
        })
        body.classList.remove('overlay-removed')
        body.classList.remove('locked')
        e.preventDefault
    });
})
overlay.forEach(x => {
    x.addEventListener('click', function(e){
        cartContainers.forEach(cartContainer => {
            cartContainer.classList.remove('active')
        })
        body.classList.remove('locked')
        body.classList.add('overlay-removed')
    })
})
